module.exports = __webpack_public_path__ + "img/levelup-icon-arrow-up.9d9a36d7.svg";